// extracted by mini-css-extract-plugin
export default {"DocumentsListContainer":"w80R3jP6","DocumentsListCenterText":"l5g037rS","DocumentRow":"xCK9IT6q"};